module.exports = "<div class=\"loading-grid-overlay\">\n  <mat-spinner></mat-spinner>\n</div>\n"